import { TrendingUp, TrendingDown } from "lucide-react";

interface Props {
  label: string;
  value: number;
  previousValue?: number;
  format?: "number" | "compact";
}

function formatNumber(n: number, format: "number" | "compact" = "number"): string {
  if (format === "compact") {
    if (n >= 1_000_000) return (n / 1_000_000).toFixed(1) + "M";
    if (n >= 1_000) return (n / 1_000).toFixed(1) + "K";
  }
  return n.toLocaleString();
}

export function MetricCard({ label, value, previousValue, format = "number" }: Props) {
  const hasTrend = previousValue !== undefined && previousValue > 0;
  const change = hasTrend ? ((value - previousValue!) / previousValue!) * 100 : 0;
  const isPositive = change >= 0;

  return (
    <div className="rounded-xl border border-border bg-white p-5">
      <p className="text-sm font-medium text-neutral-500">{label}</p>
      <p className="mt-2 text-3xl font-bold tracking-tight tabular-nums">
        {formatNumber(value, format)}
      </p>
      {hasTrend && (
        <div
          className={`mt-2 flex items-center gap-1 text-sm ${
            isPositive ? "text-success" : "text-danger"
          }`}
        >
          {isPositive ? (
            <TrendingUp className="h-4 w-4" />
          ) : (
            <TrendingDown className="h-4 w-4" />
          )}
          <span className="tabular-nums">
            {isPositive ? "+" : ""}
            {change.toFixed(1)}%
          </span>
        </div>
      )}
    </div>
  );
}
